import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getNavigation } from "../../../app-navigation";

// Henuz backend'i/ekrani olmayan menu ogeleri icin gecici yer tutucu.
// Menu yapisi hazir; ilgili modul gelistirilince bu route gercek sayfayla degistirilir.
export default function ComingSoonPage() {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    // Aktif path'in menudeki basligini bul (gosterimde kullanmak icin).
    const title = (() => {
        for (const group of getNavigation(t) as any[]) {
            if (group.path === pathname) return group.text;
            for (const item of group.items ?? []) {
                if (item.path?.split("?")[0] === pathname) return item.text;
            }
        }
        return "";
    })();

    return (
        <div
            className="flex flex-col items-center justify-center h-full w-full text-center"
            style={{ color: "var(--base-text-color)", padding: 24, gap: 16 }}
        >
            <i className="dx-icon-toolbox" style={{ fontSize: 56, color: "var(--accent-color, #6366F1)" }} />
            <h2 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>
                {title || t("comingSoon")}
            </h2>
            <p style={{ color: "var(--subtitle-text-color)", maxWidth: 420, margin: 0 }}>
                {t("comingSoonDesc")}
            </p>
        </div>
    );
}
